import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Table,
  Tab,
  Nav,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { RiErrorWarningLine } from "react-icons/ri";
import TradingViewWidget, { Themes } from "react-tradingview-widget";
import "../spot_styles/spotmiddle.css";
import "../spot_styles/spotlower.css";
import WebSocket from "websocket";
import * as Yup from "yup";
import { useFormik } from "formik";
import { AXIOS, api_key } from "../../../config";
import { toPlainString } from "../../../helperData/helper";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { orderType, updateIsCreated } from "../../../store/spot";
import { formatNumberWithDecimals } from "../../../helperData/helper";
import { any } from "prop-types";
export default function OrderBook() {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Place a market order based on the total amount of assets you want to
      spend, and the final executed volume and price will depend on the actual
      transaction result.
    </Tooltip>
  );

  let userid = sessionStorage.getItem("userid");
  console.log("userid inside orderbook", userid);
  let commission = 0.001
  const [walletBalance, setWalletBalance] = useState(0);
  const [coinBalance, setCoinBalance] = useState(0);

  const [activeModal, setActiveModal] = useState(true);
  const [showLimitOrder, setShowLimitOrder] = useState(true);
  const { sellOrderInfo, buyOrderInfo, isCreatedOrder } = useSelector(
    (state: any) => state.spot
  );

  const { isLogin } = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();
  const {
    pairName,
    pairOneSymbol,
    pairTwoSymbol,
    symbolOneId,
    symbolTwoId,
  } = useSelector((state: any) => state.pair);

  const spotSchema = Yup.object().shape({
    limitordersellprice: Yup.string().required("Price is required filed"),
    limitordersellamount: Yup.string().required("Amount is required filed"),
    limitorderbuyprice: Yup.string().required("Price is required filed"),
    limitorderbuyamount: Yup.string().required("Amount is required filed"),
    marketorderbuyprice: Yup.string().required("Price is required filed"),
    marketorderbuyamount: Yup.string().required("Amount is required filed"),
    marketordersellprice: Yup.string().required("Price is required filed"),
    marketordersellamount: Yup.string().required("Amount is required filed"),
  });
  const formik = useFormik({
    initialValues: {
      limitordersellprice: 0,
      limitordersellamount: 0,
      limitordersellpercent: 0,
      limitorderselltotal: 0,
      limitorderbuyprice: 0,
      limitorderbuyamount: 0,
      limitorderbuypercent: 0,
      limitorderbuytotal: 0,
      marketorderbuyprice: 0,
      marketorderbuyamount: 0,
      marketorderbuypercent: 0,
      marketorderbuytotal: 0,
      marketordersellprice: 0,
      marketordersellamount: 0,
      marketordersellpercent: 0,
      marketorderselltotal: 0,
    },
    validationSchema: spotSchema,

    onSubmit: async (values, action) => {
      // await createLaunchpad(values);
      // action.resetForm();
    },
  });
  const handleSpotFormValue = async (e: any) => {
    let value = e.target.value;
    let name = e.target.name;
    console.log("name", name);
    if (name == "limitordersellprice") {
      formik.setValues({
        ...formik.values,
        limitorderselltotal: value * formik.values.limitordersellamount,
        limitordersellpercent: (value / walletBalance) * 100,
      });
    } else if (name == "limitordersellamount") {
      formik.setValues({
        ...formik.values,
        limitorderselltotal: value * formik.values.limitordersellprice,
        limitordersellpercent: (value / walletBalance) * 100,
      });
    } else if (name == "limitorderbuyprice") {
      formik.setValues({
        ...formik.values,
        limitorderbuytotal: value * formik.values.limitorderbuyamount,
        limitorderbuypercent: (value / walletBalance) * 100,
      });
    } else if (name == "limitorderbuyamount") {
      formik.setValues({
        ...formik.values,
        limitorderbuytotal: value * formik.values.limitorderbuyprice,
        limitorderbuypercent: (value / walletBalance) * 100,
      });
    } else if (name == "marketordersellprice") {
      formik.setValues({
        ...formik.values,
        marketorderselltotal: value * formik.values.marketordersellamount,
        marketordersellpercent: (value / walletBalance) * 100,
      });
    } else if (name == "marketordersellamount") {
      formik.setValues({
        ...formik.values,
        marketorderselltotal: value * formik.values.marketordersellprice,
        marketordersellpercent: (value / walletBalance) * 100,
      });
    } else if (name == "marketorderbuyprice") {
      formik.setValues({
        ...formik.values,
        marketorderbuytotal: value * formik.values.marketorderbuyamount,
        marketorderbuypercent: (value / walletBalance) * 100,
      });
    } else if (name == "marketorderbuyamount") {
      formik.setValues({
        ...formik.values,
        marketorderbuytotal: value * formik.values.marketorderbuyprice,
        marketorderbuypercent: (value / walletBalance) * 100,
      });
    }
    formik.handleChange(e);
  };
  // const ws = new WebSocket("wss://ws.bitstamp.net");
  // ws.onopen = () => {
  //   console.log("WebSocket connection established");
  // };

  // ws.onmessage = (event: any) => {
  //   console.log("Received message:", event.data);
  // };

  // ws.onclose = () => {
  //   console.log("WebSocket connection closed");
  // };

  // ws.onerror = (error: any) => {
  //   console.error("WebSocket error:", error);
  // };
  const handleSubmit = async (
    type: string,
    method: string,
    percent: number,
    amount: number,
    target_price: number
  ) => {
    if (isLogin) {
      // activeModal?(amount * target_price)+commission<walletBalance:amount<coinBalance && walletBalance>commission
      if (activeModal ? Number(amount * target_price) + commission < walletBalance : amount < coinBalance && walletBalance >= commission) {

        AXIOS.post("addOrders", {
          api_key: api_key,
          user_id: userid,
          percent: toPlainString(percent),
          amount: amount,
          pair_name: pairName,
          type: type,
          method: method,
          target_price: target_price,
          symbolId: method == "buy" ? symbolOneId : symbolOneId,
        }).then((response) => {
          getBalance();

          dispatch(updateIsCreated());
        }).catch((error: any) => {
          toast.error(error.message)

        })
      } else {
        toast.error("Insufficient balance");
      }
    } else {
      toast.error("Login First");
    }
  };
  const getBalance = async () => {
    try {
      let response = await AXIOS
        .post('getWalletCoinBalance', {
          api_key: api_key,
          user_id: userid,
          coin_id: symbolTwoId
        })
      let coinBalance = await AXIOS
        .post('getWalletCoinBalance', {
          api_key: api_key,
          user_id: userid,
          coin_id: symbolOneId
        })
      console.log('balance', response.data.data)
      setWalletBalance(response.data.data.amount)
      setCoinBalance(coinBalance.data.data.amount)

    } catch (error: any) {
      // toast.error(error.message)
    }
  };
  useEffect(() => {
    if (pairName && isLogin) {
      getBalance();
    }
  }, [pairName, isCreatedOrder, isLogin]);
  useEffect(() => {
    formik.setValues({
      ...formik.values,
      limitordersellprice: buyOrderInfo.targetPrice,
      limitordersellamount: buyOrderInfo.sumAmount,
      limitorderselltotal: buyOrderInfo.targetPrice * buyOrderInfo.sumAmount,
    });
  }, [buyOrderInfo]);
  useEffect(() => {
    formik.setValues({
      ...formik.values,
      limitorderbuyprice: sellOrderInfo.targetPrice,
      limitorderbuyamount: sellOrderInfo.sumAmount,
      limitorderbuytotal: sellOrderInfo.targetPrice * sellOrderInfo.sumAmount,
    });
  }, [sellOrderInfo]);

  return (
    <Container fluid className="m-0 p-0">
      <Row>
        <Col>
          <div className="spot_middle_right">
            <div className="spot_middle_btns d-flex align-items-center justify-content-between">
              <div className="spot_middle_btn d-flex gap-2 gap-lg-3 gap-xl-4">
                <Button
                  className={`limit_btn ${showLimitOrder == true ? "scnd_btn1" : "scnd_btn2"
                    }`}
                  onClick={() => {
                    setShowLimitOrder(true);
                    dispatch(orderType("limit"));
                  }}
                >
                  Limit orders
                </Button>
                <Button
                  className={`limit_btn ${showLimitOrder == false ? "scnd_btn1" : "scnd_btn2"
                    } `}
                  onClick={() => {
                    setShowLimitOrder(false);
                    dispatch(orderType("market"));
                  }}
                >
                  Market orders
                </Button>
              </div>
              <div className="spot_middle_rules">
                <a href="http://" target="_blank" rel="noopener noreferrer">
                  Rules
                </a>
              </div>
            </div>
            {showLimitOrder ? (
              <>
                <div>
                  <div className="scnd_btn mt-3 mb-3 d-flex w-100">
                    <div
                      className={`${activeModal == true ? "buy_btn" : "buy_sell_btn"
                        } w-100 mr-0`}
                      onClick={() => setActiveModal(true)}
                    >
                      Buy
                    </div>
                    <div
                      className={`${activeModal == false ? "sell_btn" : "buy_sell_btn"
                        } w-100 `}
                      onClick={() => setActiveModal(false)}
                    >
                      Sell
                    </div>
                  </div>
                  <p className="balance_para">
                    Avbl:{" "}
                    {formatNumberWithDecimals(
                      activeModal ? walletBalance : coinBalance,
                      5
                    )}{" "}
                    {activeModal ? pairTwoSymbol : pairOneSymbol}
                  </p>

                  {activeModal ? (
                    <Form className="orderBook_form">
                      {/* <div className="orderBook_inputSpan"> */}
                      {/* <span className="ob_span1">Price</span> */}
                      <InputGroup className="my-3 inp_group">
                        <InputGroup.Text>Price</InputGroup.Text>
                        <Form.Control
                          type="number"
                          // placeholder="Price"
                          name="limitordersellprice"
                          value={formik.values.limitordersellprice}
                          onChange={(e) => {
                            handleSpotFormValue(e);
                          }}
                          className="spot_middle_form text-end"
                        />
                        <InputGroup.Text>{pairTwoSymbol}</InputGroup.Text>
                      </InputGroup>

                      {/* <span className="ob_span2">USDT</span> */}
                      {/* </div> */}
                      <InputGroup className="my-3 inp_group">
                        <InputGroup.Text>Amount</InputGroup.Text>
                        <Form.Control
                          type="number"
                          // placeholder="Amount"
                          name="limitordersellamount"
                          value={formik.values.limitordersellamount}
                          onChange={(e) => {
                            handleSpotFormValue(e);
                          }}
                          className="spot_middle_form text-end"
                        />
                        <InputGroup.Text>{pairOneSymbol}</InputGroup.Text>
                      </InputGroup>
                      <Form.Range
                        className="mt-2 mb-2 orderbook_range"
                        min="0"
                        max="100"
                        defaultValue="0"
                      />
                      {/* <Form.Control
                        type="number"
                        placeholder="Total"
                        name="limitorderselltotal"
                        value={formik.values.limitorderselltotal}
                        className="spot_middle_form text-end my-2"
                      /> */}
                      <div
                        className="spot_middle_form_lastbtn mb-3"
                        onClick={() => {
                          handleSubmit(
                            "limit",
                            "buy",
                            formik.values.limitordersellpercent,
                            formik.values.limitordersellamount,
                            formik.values.limitordersellprice
                          );
                        }}
                      >
                        <Button variant="success" className="w-100 ">
                          BUY
                        </Button>
                      </div>
                    </Form>
                  ) : (
                    <Form className="orderBook_form">
                      <InputGroup className="my-3 inp_group">
                        <InputGroup.Text>Price</InputGroup.Text>
                        <Form.Control
                          type="number"
                          // placeholder="Price"
                          className="spot_middle_form text-end"
                          name="limitorderbuyprice"
                          value={formik.values.limitorderbuyprice}
                          onChange={(e) => {
                            handleSpotFormValue(e);
                          }}
                        />
                        <InputGroup.Text>{pairTwoSymbol}</InputGroup.Text>
                      </InputGroup>

                      <InputGroup className="my-3 inp_group">
                        <InputGroup.Text>Amount</InputGroup.Text>
                        <Form.Control
                          type="number"
                          // placeholder="Amount"
                          name="limitorderbuyamount"
                          value={formik.values.limitorderbuyamount}
                          onChange={(e) => {
                            handleSpotFormValue(e);
                          }}
                          className="spot_middle_form text-end"
                        />
                        <InputGroup.Text>{pairOneSymbol}</InputGroup.Text>
                      </InputGroup>

                      <Form.Range
                        className="mt-2 mb-2 orderbook_range"
                        min="0"
                        max="100"
                        defaultValue="0"
                      />

                      {/* <Form.Control
                        type="number"
                        placeholder="Total"
                        className="spot_middle_form text-end my-2"
                        name="limitorderbuytotal"
                        value={formik.values.limitorderbuytotal}
                      /> */}

                      <div
                        className="spot_middle_form_lastbtn mb-3"
                        onClick={() => {
                          handleSubmit(
                            "limit",
                            "sell",
                            formik.values.limitorderbuypercent,
                            formik.values.limitorderbuyamount,
                            formik.values.limitorderbuyprice
                          );
                        }}
                      >
                        <Button variant="danger" className="w-100 ">
                          SELL
                        </Button>
                      </div>
                    </Form>
                  )}
                </div>
              </>
            ) : (
              <>
                <div>
                  <div className="scnd_btn mt-3 mb-3 d-flex w-100">
                    <div
                      className={`${activeModal == true ? "buy_btn" : "buy_sell_btn"
                        } w-100 mr-0`}
                      onClick={() => setActiveModal(true)}
                    >
                      Buy
                    </div>
                    <div
                      className={`${activeModal == false ? "sell_btn" : "buy_sell_btn"
                        } w-100`}
                      onClick={() => setActiveModal(false)}
                    >
                      Sell
                    </div>
                  </div>
                  <p className="balance_para">
                    Avbl:{" "}
                    {formatNumberWithDecimals(
                      activeModal ? walletBalance : coinBalance,
                      5
                    )}{" "}
                    {activeModal ? pairTwoSymbol : pairOneSymbol}
                  </p>

                  {activeModal ? (
                    <Form className="orderBook_form">
                      <InputGroup className="my-3 inp_group">
                        <InputGroup.Text>Price</InputGroup.Text>
                        <Form.Control
                          type="number"
                          // placeholder="Price"
                          className="spot_middle_form text-end"
                          name="marketordersellprice"
                          value={formik.values.marketordersellprice}
                          onChange={(e) => {
                            handleSpotFormValue(e);
                          }}
                        />
                        <InputGroup.Text>{pairTwoSymbol}</InputGroup.Text>
                      </InputGroup>
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="Amount"
                      >
                        <div className="spot_middle_form_btns mt-3 mb-3">
                          <Row>
                            <Col>
                              <Nav variant="pills" className="flex-row w-100">
                                <Nav.Item className="w-50 pe-2">
                                  <Nav.Link
                                    eventKey="Amount"
                                    className="text-center py-2 spot_middle_form"
                                  >
                                    Amount
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="w-50 ps-2">
                                  <Nav.Link
                                    eventKey="Total"
                                    className="text-center spot_middle_form"
                                  >
                                    Total
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={renderTooltip}
                                    >
                                      <button
                                      className="p-0 ps-2"
                                        style={{
                                          background: "none",
                                          border: "none",
                                        }}
                                      >
                                        <RiErrorWarningLine style={{ color: 'var(--text-clr)' }} />
                                      </button>
                                    </OverlayTrigger>
                                  </Nav.Link>
                                </Nav.Item>
                              </Nav>
                            </Col>
                          </Row>
                        </div>
                        <Col>
                          <Tab.Content>
                            <Tab.Pane
                              eventKey="Amount"
                              className="orderBook_form"
                            >
                              <InputGroup className="my-3 inp_group">
                                <InputGroup.Text>Amount</InputGroup.Text>
                                <Form.Control
                                  type="number"
                                  // placeholder="Amount"
                                  className="spot_middle_form text-end"
                                  name="marketordersellamount"
                                  value={formik.values.marketordersellamount}
                                  onChange={(e) => {
                                    handleSpotFormValue(e);
                                  }}
                                />
                                <InputGroup.Text>{pairOneSymbol}</InputGroup.Text>
                              </InputGroup>
                            </Tab.Pane>
                            <Tab.Pane
                              eventKey="Total"
                              className="orderBook_form"
                            >
                              <InputGroup className="my-3 inp_group">
                                <InputGroup.Text>Total</InputGroup.Text>
                                <Form.Control
                                  type="number"
                                  // placeholder="Total"
                                  className="spot_middle_form text-end"
                                  name="marketorderselltotal"
                                // value={formik.values.marketordersellamount}
                                // onChange={(e) => {
                                //   handleSpotFormValue(e);
                                // }}
                                />
                                <InputGroup.Text>{pairTwoSymbol}</InputGroup.Text>
                              </InputGroup>
                            </Tab.Pane>
                          </Tab.Content>
                        </Col>
                      </Tab.Container>

                      <Form.Range
                        className="mt-2 mb-2 orderbook_range"
                        min="0"
                        max="100"
                        defaultValue="0"
                      />
                      {/* <Form.Control
                        type="number"
                        placeholder="Total"
                        name="marketorderselltotal"
                        value={formik.values.marketorderselltotal}
                        className="spot_middle_form my-2"
                      /> */}
                      <div
                        className="spot_middle_form_lastbtn mb-3"
                        onClick={() => {
                          handleSubmit(
                            "market",
                            "buy",
                            formik.values.marketordersellpercent,
                            formik.values.marketordersellamount,
                            formik.values.marketordersellprice
                          );
                        }}
                      >
                        <Button variant="success" className="w-100 ">
                          BUY
                        </Button>
                      </div>
                    </Form>
                  ) : (
                    <Form className="orderBook_form">
                      <InputGroup className="my-3 inp_group">
                        <InputGroup.Text>Price</InputGroup.Text>
                        <Form.Control
                          type="number"
                          // placeholder="Price"
                          className="spot_middle_form text-end"
                          name="marketorderbuyprice"
                          value={formik.values.marketorderbuyprice}
                          onChange={(e) => {
                            handleSpotFormValue(e);
                          }}
                        />
                        <InputGroup.Text>Market</InputGroup.Text>
                        <InputGroup.Text>{pairOneSymbol}</InputGroup.Text>
                      </InputGroup>

                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="Amount"
                      >
                        <div className="spot_middle_form_btns mt-3 mb-3">
                          <Row>
                            <Col>
                              <Nav variant="pills" className="flex-row w-100">
                                <Nav.Item className="w-50 pe-2">
                                  <Nav.Link
                                    eventKey="Amount"
                                    className="text-center py-2 spot_middle_form"
                                  >
                                    Amount
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="w-50 ps-2">
                                  <Nav.Link
                                    eventKey="Total"
                                    className="text-center spot_middle_form"
                                  >
                                    Total
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={renderTooltip}
                                    >
                                      <button
                                      className="p-0 ps-2"
                                        style={{
                                          background: "none",
                                          border: "none",
                                        }}
                                      >
                                        <RiErrorWarningLine style={{ color: 'var(--text-clr)' }} />
                                      </button>
                                    </OverlayTrigger>
                                  </Nav.Link>
                                </Nav.Item>
                              </Nav>
                            </Col>
                          </Row>
                        </div>
                        <Col>
                          <Tab.Content>
                            <Tab.Pane
                              eventKey="Amount"
                              className="orderBook_form"
                            >
                              <InputGroup className="my-3 inp_group">
                                <InputGroup.Text>Amount</InputGroup.Text>
                                <Form.Control
                                  type="number"
                                  placeholder="Amount"
                                  className="spot_middle_form text-end"
                                  name="marketordersellamount"
                                  value={formik.values.marketordersellamount}
                                  onChange={(e) => {
                                    handleSpotFormValue(e);
                                  }}
                                />
                                <InputGroup.Text>{pairOneSymbol}</InputGroup.Text>
                              </InputGroup>
                            </Tab.Pane>
                            <Tab.Pane
                              eventKey="Total"
                              className="orderBook_form"
                            >
                              <InputGroup className="my-3 inp_group">
                                <InputGroup.Text>Total</InputGroup.Text>
                                <Form.Control
                                  type="number"
                                  // placeholder="Total"
                                  className="spot_middle_form text-end"
                                  name="marketorderselltotal"
                                // value={formik.values.marketordersellamount}
                                // onChange={(e) => {
                                //   handleSpotFormValue(e);
                                // }}
                                />
                                <InputGroup.Text>{pairTwoSymbol}</InputGroup.Text>
                              </InputGroup>
                            </Tab.Pane>
                          </Tab.Content>
                        </Col>
                      </Tab.Container>
                      <Form.Range
                        className="mt-2 mb-2 orderbook_range"
                        min="0"
                        max="100"
                        defaultValue="0"
                      />
                      {/* <Form.Control
                        type="number"
                        placeholder="Total"
                        className="spot_middle_form my-2"
                        name="marketorderbuytotal"
                        value={formik.values.marketorderbuytotal}
                      /> */}
                      <div
                        className="spot_middle_form_lastbtn mb-3"
                        onClick={() => {
                          handleSubmit(
                            "market",
                            "sell",
                            formik.values.marketorderbuypercent,
                            formik.values.marketorderbuyamount,
                            formik.values.marketorderbuyprice
                          );
                        }}
                      >
                        <Button variant="danger" className="w-100 ">
                          SELL
                        </Button>
                      </div>
                    </Form>
                  )}
                </div>
              </>
            )}
            <div className="spot_middle_rules text-end">
              <a href="http://" target="_blank" rel="noopener noreferrer">
                Fee Level
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
